const DownloadItem = (props) => {

    if (props.data.hasOwnProperty("invoice_document_1") && Array.isArray(props.data.invoice_document_1) && props.data.invoice_document_1.length > 0) {
        return (
            <i className="fa fa-download" onClick={(e) => props?.viewDownload(props)} style={{ fontSize: "25px", cursor: "pointer" }}></i>
        )
    }
}
export default DownloadItem